import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {API, AssetDTO} from '../../../../services/api/api';
import {ModalNavigationService} from '../../../../services/gui/modal/modal-navigation.service';
import {UtilService} from '../../../../services/util.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ModalNavigationComponent} from '../../../../services/gui/modal/modal-navigation-component';
import {ModalService} from '../../../../services/gui/modal/modal.service';
import {AssetService} from '../../../../services/assets/asset.service';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'sb-page-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss'],
  standalone: false,
})
export class AssetListComponent implements OnInit, ModalNavigationComponent, OnDestroy {
  public readonly modalNavigationService = inject(ModalNavigationService);
  public readonly modalService = inject(ModalService);
  public readonly api = inject(API);
  public readonly assetService = inject(AssetService);
  public readonly route = inject(ActivatedRoute);
  public readonly util = inject(UtilService);
  public readonly permissionService = inject( PermissionService);

  isInModalContext: boolean;

  ngOnInit(): void {
    if (!this.assetService.selectedRepository) {
      this.route.params.subscribe((params: Params) => {
        const repoId = params.repositoryID ? +params.repositoryID : null;
        if (repoId) {
          this.assetService.retrieveRepo(repoId);
        }
      });
    }
  }

  selectAsset(asset: AssetDTO) {
    if (this.isInModalContext) {
      this.modalNavigationService.result(asset);
    }
  }

  ngOnDestroy() {
    this.assetService.selectedAsset = null;
    this.assetService.showSideBar = false;
  }

  applyFiltering(filterMap: Map<string, any[]>) {
    this.setRequestOptions(filterMap);
    this.assetService.requestDebouncedAssets();
  }

  setRequestOptions(filterMap: Map<string, any[]>) {
    this.assetService.searchAssets = filterMap.get('search')?.[0];
    this.assetService.exactMatchAssets = filterMap.get('exactMatch')?.[0];
  }
}
